

// src/App.js - FINAL CORRECT + DESKTOP ONLY
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import Login from './components/pages/Login';
import Dashboard from './components/pages/Dashboard';
import Companies from './components/pages/Companies';
import CompanyJobs from './components/pages/CompanyJobs';
import Jobs from './components/pages/Jobs';
import JobCandidates from './components/pages/JobCandidates';
import Candidates from './components/pages/Candidates';
import Placements from './components/pages/CommingSoon';
import Interviews from './components/pages/CommingSoon';
import './styles/global.css';
import ProtectedRoute from "./components/ProtectedRoute";

<Route path="/dashboard" element={<Dashboard />} />
function App() {


 // right click block code 

 
  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     // F12
  //     if (e.key === "F12") {
  //       e.preventDefault();
  //     }

  //     // Ctrl + Shift + I / J / C
  //     if (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) {
  //       e.preventDefault();
  //     }

  //     // Ctrl + U (View Source)
  //     if (e.ctrlKey && e.key === "u") {
  //       e.preventDefault();
  //     }
  //   };

  //   const handleRightClick = (e) => {
  //     e.preventDefault();
  //   };

  //   document.addEventListener("keydown", handleKeyDown);
  //   document.addEventListener("contextmenu", handleRightClick);

  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //     document.removeEventListener("contextmenu", handleRightClick);
  //   };
  // }, []);



  // 🔥 MOBILE BLOCK LOGIC
  useEffect(() => {
    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      document.getElementById("mobile-block").style.display = "flex";
      document.body.style.overflow = "hidden";
    }
  }, []);

  return (
    <AuthProvider>
      {/* Mobile Block Overlay */}
      <div id="mobile-block" style={{
        display: "none",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "white",
        zIndex: 999999,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        fontSize: "22px",
        fontWeight: "600"
      }}>
        ❌ Mobile Not Supported
        <br />
        Please open this CRM on a Desktop or Laptop.
      </div>

      <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Route */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="companies" element={<Companies />} />
            <Route path="company/:companyId/jobs" element={<CompanyJobs />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="job/:jobId/candidates" element={<JobCandidates />} />
            <Route path="candidates" element={<Candidates />} />
            <Route path="placements" element={<Placements />} />
            <Route path="interviews" element={<Interviews />} />
          </Route>

          {/* Catch All */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
